import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "../slices/userSlice";

const combinedReducers = combineReducers({
    auth: userReducer
})

export default combinedReducers;